<template>
  <div>
    <section>
    <div class="chart-wrapper">
    <div class="container">
    <div class="date">
      <datepicker v-model="value"></datepicker>

    <!-- <a href="#" style="float:left"><i class="fa fa-angle-left" aria-hidden="true"></i></a>
    <span>2017.04.07</span>
    <a href="#" style="float:right"><i class="fa fa-angle-right" aria-hidden="true"></i></a> -->
    </div>
    </div><!-- end time -->

      <div class="multi-chart">
        <div class="container">
        <div class="row">
          <div class="col-sm-3">
            <div class="radio-chart">
            <form class="form">
              <div class="radio">
                <label class="male-radio control control--radio">
                  <input name="optionsRadios" id="#" class="radio-btn" value="temp" checked="checked" type="radio" v-model="radioType" v-on:click="clicked">Temperature Vs PM <sub>2.5</sub>
                  <div class="control__indicator"></div>
                </label>
                </div>
                <div class="radio">
                <label class="male-radio control control--radio">
                  <input name="optionsRadios" id="#" class="radio-btn" value="wind" type="radio" v-model="radioType" v-on:click="clicked">Wind Vs PM <sub>2.5</sub>
                  <div class="control__indicator"></div>
                </label>
              </div>
              <!--  <div class="radio">
                <label class="male-radio control control--radio">
                  <input name="optionsRadios" id="#" class="radio-btn" value="pressure" type="radio" v-model="radioType" :click="fetchData">Pressure
                  <div class="control__indicator"></div>
                </label>
              </div> -->
            </form>
            </div><!-- end radio-chart -->
          </div><!-- end col -->
          <div class="col-sm-9">
            <div class="right-display table-responsive">
              <div id="container"  style="min-width: 400px; height: 400px; margin: 0 auto" data-highcharts-chart="0">
                <highcharts :options="options" ></highcharts>
              </div>
            </div><!-- end right-display -->
          </div><!-- end col -->
        </div><!-- end row -->
        </div>
      </div><!-- end multi-chart -->
     </div><!-- end chart-wrapper -->
    </section>


  <!-- Weather Table -->
  <section>
  <div class="container">
  <div class="pollution-table">
    <div class="pollution-title">
        <h4>Weather And Pollution</h4>
    </div><!-- end pollution-tile -->
    <div class="table-responsive table-block tbl-weather">
              <table class="table table-striped small">
                <thead>
                  <tr class="dayweather1">
                  <td class="header">&nbsp;
                  </td><td class="header"><strong>midnight-1</strong></td>
                  <td class="header"><strong>1-2am</strong></td>
                  <td class="header"><strong>2-3am</strong></td>
                  <td class="header"><strong>3-4am</strong></td>
                  <td class="header"><strong>4-5am</strong></td>
                  <td class="header"><strong>5-6am</strong></td>
                  <td class="header"><strong>6-7am</strong></td>
                  <td class="header"><strong>7-8am</strong></td>
                  <td class="header"><strong>8-9am</strong></td>
                  <td class="header"><strong>9-10am</strong></td>
                  <td class="header"><strong>10-11am</strong></td>
                  <td class="header"><strong>11-noon</strong></td>
                  <td class="header"><strong>noon-1pm</strong></td>
                  <td class="header"><strong>1-2pm</strong></td>
                  <td class="header"><strong>2-3pm</strong></td>
                  <td class="header"><strong>3-4pm</strong></td>
                  <td class="header"><strong>4-5pm</strong></td>
                  <td class="header"><strong>5-6pm</strong></td>
                  <td class="header"><strong>6-7pm</strong></td>
                  <td class="header"><strong>7-8pm</strong></td>
                  <td class="header"><strong>8-9pm</strong></td>
                  <td class="header"><strong>9-10pm</strong></td>
                  <td class="header"><strong>10-11pm</strong></td>
                  <td class="header"><strong>11-midnight</strong></td>
                </tr>
                </thead>

                <tbody>
                  <tr>
                      <th class="row">PM<sub>2.5</sub></th>

                      <td v-for="data in pm25">{{data.y}}</td>
                  </tr>
                    <tr>
                        <th class="row">Rain(%)</th>
                        <td v-for="data in rainData">{{data}}</td>
                    </tr>
                    <tr>
                      <th class="row">Temperature</th>
                      <td v-for="data in tempData">{{data}}</td>
                    </tr>
                    <tr>
                     <th class="row">Wind Speed</th>
                     <td v-for="data in windData">{{data}}</td>
                    </tr>
                    <tr>
                     <th class="row">Clouds</th>
                     <td v-for="data in cloudsData">{{data}}</td>
                    </tr>
                    <tr>
                       <th class="row">Wind Degree</th>
                       <td v-for="data in windDegreeData">{{data}}</td>

                    </tr>
                    <tr>
                      <th class="row">Relative humidity</th>
                      <td v-for="data in humidityData">{{data}}</td>
                    </tr>
                    <tr>
                      <th class="row">Pressure </th>
                      <td v-for="data in pressureData">{{data}}</td>
                    </tr>
                 </tbody>
            </table>
        </div>

   </div><!-- end pollution-table -->
  </div><!-- end container -->
  </section>
</div>

</template>

<script>
import {HTTP} from '../http-common.js'
import Vue from 'vue';
import VueHighcharts from 'vue-highcharts';
import Datepicker from './Datepicker.vue';
import * as moment from 'moment-timezone';
//var moment = require('moment-timezone');
var current_time = moment().tz("Asia/Kathmandu").format("h");
// var current_time = moment();
//var GMT_current_time = current_time.tz("Europe/London").format();
Vue.use(VueHighcharts);
// global register

var options = {
  chart: {
      zoomType: 'xy'
  },
  title: {
      text: ''
  },
  xAxis: [{
      categories: [],
      crosshair: true,
      max:23
  }],
  yAxis: [{ // Primary yAxis
      labels: {
          format: '{value}°C',
          style: {
              color: '#90ed7d'
          }
      },
      title: {
          text: 'Weather',
          style: {
              color: '#90ed7d'
          }
      },
      opposite: true,
      max : 40

  }, { // Secondary yAxis
      max : 150,
      gridLineWidth: 0,
      title: {
          text: 'Pollution',
          style: {
              color: '#7cb5ec'
          }
      },
      labels: {
          format: '{value} µg/m³',
          style: {
              color: '#7cb5ec'
          }
      }
  }],
tooltip: {
    shared: true
},
legend: {
    layout: 'vertical',
    backgroundColor: '#FFFFFF'
},
credits: {
  enabled: false
},
series: [{
    name: 'PM2.5',
    type: 'column',
    yAxis: 1,
    data: [],
    tooltip: {
        valueSuffix: ' µg/m³'
    },
    showInLegend: false,

},{
    name: 'Temperature',
    type: 'spline',
    color: '#90ed7d',
    data: [],
    tooltip: {
        valueSuffix: ' °C'
    },
    showInLegend: false,
}]
};

export default {
  name: 'daily',
  data () {
    return {
      fetchedData: null,
      loading: true,
      error: false,
      show: true,
      pollutionTitle : null,
      chartTitle : null,
      categories : null,
      pollutionData : null,
      weathersData : null,
      query: '',
      options: options,
      value : '',
      pm25 : [],
      rainData : [],
      tempData : [],
      windData: [],
      cloudsData:[],
      windDegreeData:[],
      humidityData:[],
      pressureData:[],
      radioType: 'temp',
      windChartData:''
    }
  },
  watch: {
    value: function() {
      this.fetchData(this.value)
    }
  },
  mounted: function(){
      this.fetchData()
  },
  methods : {
              clicked:function(){
                this.fetchData(this.value)
              },
              fetchData(value='',radio='') {
                var vm = this
                this.loading = true
                var url = 'pollution-weather'
                if(value!=''){

                  var  dateValue = new Date(value)
                  var dateFormat = this.parseDate(dateValue)
                  url = url+'?date='+dateFormat

                }else{
                  var  dateValue = new Date()
                  var dateFormat = this.parseDate(dateValue)
                }
                var todayDate = new Date()
                todayDate = this.parseDate(todayDate)
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response

                    this.loading = false
                    this.fetchedData = jsonData
                    this.categories = this.getcategories(jsonData.data.data)
                    this.pollutionData = this.getpollution(jsonData.data.data)
                    this.weathersData = this.getweather(jsonData.data.data)
                    this.windChartData=this.getwindChart(jsonData.data.data)
                    if(jsonData.data.date==todayDate){
                      this.pollutionTitle = "Average Hourly  Pollution and Weather Data of Kathmandu for today"
                      this.chartTitle = "Average Hourly  Pollution and Weather Data of Kathmandu"
                    }else{
                      this.pollutionTitle = "Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                      this.chartTitle = "Average Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                    }
                    this.options.xAxis[0].categories = this.categories
                    this.options.series[0].data = this.pollutionData
                    this.options.series[1].data = this.weathersData
                    if(this.radioType=='temp'){
                      this.options.series[1].data = this.weathersData
                      this.options.series[1].name='temperature' 
                      this.options.series[1].tooltip.valueSuffix=' °C'
                      this.options.yAxis[0].max=40 
                      this.options.yAxis[0].labels.format='{value}°C'
                    }
                    else if(this.radioType=='wind'){

                      this.options.series[1].data = this.windChartData
                      this.options.series[1].name='wind' 
                      this.options.series[1].tooltip.valueSuffix='m/s'
                      this.options.yAxis[0].max=20 
                      this.options.yAxis[0].labels.format='{value}m/s'
                    }
                    this.options.title.text = this.chartTitle
                    //console.log(this.pollutionData)

                    this.pm25 = this.getpm25(jsonData.data.data)
                    this.rainData = this.getRainData(jsonData.data.data)
                    this.tempData = this.getTempData(jsonData.data.data)
                    this.windData = this.getWindData(jsonData.data.data)
                    this.cloudsData = this.getCloudsData(jsonData.data.data)
                    this.humidityData = this.getHumidityData(jsonData.data.data)
                    this.pressureData = this.getPressureData(jsonData.data.data)
                    this.windDegreeData = this.getWindDegreeData(jsonData.data.data)
                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              },
              getcategories: function(data){
                var arr = [];
                data.forEach(function(d) {

                  var from = d.hours
                  var to = parseInt(d.hours) + 1
                  var hours = from.toString()+'-'+to.toString()
                  if(d.hours>=12){
                    if(d.hours==12){
                      hours = "12-1PM"
                    }
                    else if (d.hours==23) {
                      hours = "11-midnight"
                    }
                    else{
                      hours = (from-12)+'-'+(to-12)+'PM'
                    }
                  }else{
                    if(d.hours==0){
                      hours = "midnight-1AM"
                    }else{
                        hours = from+'-'+to+'AM'
                    }
                  }
                  arr.push(hours)
                })
                return arr
              },
              getpollution: function(data){
                var arr = []
                var colors = "#1db151"
                data.forEach(function(d) {
                  if(d.pollutions.value < 10){
                    colors = "#1db151";
                  }
                  else if(d.pollutions.value >= 10 && d.pollutions.value < 25){
                    colors = "#94C953";
                  }
                  else if(d.pollutions.value >= 25 && d.pollutions.value < 40){
                    colors = "#F3EC18";
                  }
                  else if(d.pollutions.value >= 40 && d.pollutions.value < 75){
                    colors = "#FDC00F";
                  }
                  else if(d.pollutions.value >= 75 && d.pollutions.value < 150){
                    colors = "#ed1e24";
                  }
                  else if(d.pollutions.value >= 150){
                    colors = "#85439a";
                  }else{
                    colors = "#1db151";
                  }
                  if(d.pollutions.value!=0){
                    arr.push({
                        y: d.pollutions.value,
                        color:  colors
                    });
                  }
                  else{
                    d.pollutions.value=null
                    arr.push({
                        y: d.pollutions.value,
                        color:  colors
                     })
                  }
                })
                return arr
              },
              getpm25: function(data){
                var arr = []
                var colors = "#75ce95"
                data.forEach(function(d) {
                  console.log(d.pollutions.value)
                  if(d.pollutions.value < 10){
                    colors = "#1db151";
                  }
                  else if(d.pollutions.value >= 10 && d.pollutions.value < 25){
                    colors = "#94C953";
                  }
                  else if(d.pollutions.value >= 25 && d.pollutions.value < 40){
                    colors = "#F3EC18";
                  }
                  else if(d.pollutions.value >= 40 && d.pollutions.value < 75){
                    colors = "#FDC00F";
                  }
                  else if(d.pollutions.value >= 75 && d.pollutions.value < 150){
                    colors = "#ed1e24";
                  }
                  else if(d.pollutions.value >= 150){
                    colors = "#85439a";
                  }else{
                    colors = "#1db151";
                  }
                  if(d.pollutions.value==0 || d.pollutions.value==null){
                    d.pollutions.value="NA"
                    colors = "#75ce95"
                  }
                    
                  arr.push({
                        y: d.pollutions.value,
                        color:  colors
                     })
                    
                    })
               
                return arr
              },
              getweather: function(data){
                var arr = []
                data.forEach(function(d) {
                  
                  var marker = d.weathers.marker
                  var temp = d.weathers.temp
                  if(d.weathers.temp!=0){
                    if(marker!=''){
                      arr.push({
                          y: temp,
                          marker: marker
                      });
                    }else{
                      arr.push(temp)
                    }
                  }else{
                    temp=null
                    arr.push({
                          y: temp
                        })
                  }

                })

                return arr
              },
              getwindChart:function(data){
                var arr = []
                data.forEach(function(d) {
                  
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('wind_speed')) {
                    var wind_speed = parseFloat(d.weathers.details.wind_speed)
                  }else{
                    wind_speed=null
                  }
                  arr.push(wind_speed)
                })
                return arr
              },
              getTempData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var temp = "NA"
                  if(d.weathers.temp!=0){
                    temp = d.weathers.temp+"°C"
                  }
                  arr.push(temp)
                })
                return arr
              },
              getRainData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var rain = "NA"
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('rain')) {
                    rain = d.weathers.details.rain
                  }
                  arr.push(rain)
                })
                return arr
              },
              getWindData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var wind_speed = "NA"
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('wind_speed')) {
                    wind_speed = d.weathers.details.wind_speed+"m/s"
                  }
                  arr.push(wind_speed)
                })
                return arr
              },
              getCloudsData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var clouds = "NA"
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('clouds')) {
                    clouds = d.weathers.details.clouds
                  }
                  arr.push(clouds)
                })
                return arr
              },
              getHumidityData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var humidity = "NA"
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('humidity')) {
                    humidity = d.weathers.details.humidity+"%"
                  }
                  arr.push(humidity)
                })
                return arr
              },
              getWindDegreeData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var wind_degree = "NA"
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('wind_degree')) {
                    wind_degree = d.weathers.details.wind_degree
                  }
                  arr.push(wind_degree)
                })
                return arr
              },
              getPressureData:function(data){
                var arr = []
                data.forEach(function(d) {
                  var pressure = "NA"
                  if ( d.hasOwnProperty('weathers') && d.weathers.hasOwnProperty('details') && d.weathers.details.hasOwnProperty('pressure')) {
                    pressure = d.weathers.details.pressure+"hps"
                  }
                  arr.push(pressure)
                })
                return arr
              },
              parseWeather: function(data){
                var arr = []
                data.forEach(function(d) {
                  if(d.weathers.temp!=0){
                    if(d.hours==current_time){
                      var title = d.weathers.details.title
                      var pressure = d.weathers.details.pressure+"hps"
                      var humidity = d.weathers.details.humidity+"%"
                      var temperature = d.weathers.temp+"°C"
                      var windSpeed = "Wind Speed " + d.weathers.details.wind_speed+"m/s"
                      var sunrise = moment.unix(d.weathers.details.sunrise).format("hh:mm a")
                      var sunset = moment.unix(d.weathers.details.sunset).format("hh:mm a")
                      arr.push({title:title,pressure:pressure,humidity:humidity,temperature:temperature,windSpeed:windSpeed,sunrise:sunrise,sunset:sunset})
                    }
                  }

                })
                return arr
              },
              getWindDirection:function(degree){
              },
              parseDate:function(dateValue){
                var year = dateValue.getFullYear()+""
                var month = ('0' + (dateValue.getMonth()+1)).slice(-2)+""
                var day = ('0' + dateValue.getDate()).slice(-2)+""
                var dateFormat = year + "-" + month + "-" + day
                return dateFormat
              }
  },
  components: {
      Datepicker
  }
}

</script>
<style src="../assets/style.css"></style>
<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.calender{
  width:250px;
}
.calender .cell{
  height: 25px;
  line-height: 25px;
}
.date span{
  font-size:16px;
}
.radio{
  margin-bottom:25px;
}
</style>



// WEBPACK FOOTER //
// Daily.vue?685de0be